module.exports = __webpack_public_path__ + "static/media/title_5.29a52931.svg";